import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const ClubsStateLevelStem = lazy(() => import('./ClubsStateLevelStem'));
const ClubsBlockLevelStem = lazy(() => import('./ClubsBlockLevelStem'));
const ClubsDistrictLevelStem = lazy(() => import('./ClubsDistrictLevelStem'));
const ArtCultureStateLevel = lazy(() => import('./ArtCultureStateLevel'));
const ArtCultureDistrictLevel = lazy(() => import('./ArtCultureDistrictLevel'));
const KalaiThiruvizha = lazy(() => import('./KalaiThiruvizha'));
const SportsDistrictLevel = lazy(() => import('./SportsDistrictLevel'));

const CompetitionModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route path="club-state-level-stem" element={<ClubsStateLevelStem />} />
        <Route path="club-block-level-stem" element={<ClubsBlockLevelStem />} />
        <Route
          path="club-district-level-stem"
          element={<ClubsDistrictLevelStem />}
        />
        <Route path="Art_Culture_state" element={<ArtCultureStateLevel />} />
        <Route
          path="Art_Culture_district"
          element={<ArtCultureDistrictLevel />}
        />
        <Route path="kalai_thiruvizha" element={<KalaiThiruvizha />} />
        <Route path="sports-district-level" element={<SportsDistrictLevel />} />
      </Routes>
    </Suspense>
  );
};

export default CompetitionModule;
